import React from "react";
import { colors, colorsBCV } from "../../styling";
import RaisedButton from "material-ui/RaisedButton";

type Props = {
  email: string;
  onConfirm: () => void;
};

const Registered = ({ email, onConfirm }: Props) => (
  <div style={{ textAlign: "center", paddingTop: "40px" }}>
    <p>
      <span>
        Het account is aangemeld! Er is een bevestigingsmail gestuurd naar{" "}
        <span style={{ fontWeight: "bold" }}>{email}</span>.
      </span>
    </p>
    <p>
      <span>Klik op volgende om een lid te migreren voor dit account.</span>
    </p>
    <div
      style={{
        paddingTop: "30px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <RaisedButton
        // @ts-ignore
        id="verify"
        label="Volgende"
        labelColor={colors.white}
        backgroundColor={colorsBCV.secondary}
        onClick={onConfirm}
      />
    </div>
  </div>
);

export default Registered;
